import {Grid, Typography} from '@mui/material';
import AppTimerCounterTypography from 'components/typographies/AppTimerCounterTypography';
import {useGetAllTimeTrackerEntitiesWithoutPagination} from 'hooks';
import React, {useEffect} from 'react';
import {FieldsRendererProps} from './FieldsRenderer';

interface RenderTimeTrackerCounterProps extends FieldsRendererProps {
    gridSize?: number;
}
export const RenderTimeTrackerCounter: React.FC<RenderTimeTrackerCounterProps> = ({field, itemId, gridSize}) => {
    const {getAllTimeTrackerEntitiesWithoutPagination, getAllTimeTrackerEntitiesWithoutPaginationResponse} =
        useGetAllTimeTrackerEntitiesWithoutPagination();

    useEffect(() => {
        if (itemId) {
            getAllTimeTrackerEntitiesWithoutPagination({
                variables: {
                    where: {
                        itemDataId: {
                            eq: itemId,
                        },
                    },
                },
            });
        }
    }, [itemId]);

    const totalTrackerValue = React.useMemo(() => {
        if (getAllTimeTrackerEntitiesWithoutPaginationResponse) {
            return getAllTimeTrackerEntitiesWithoutPaginationResponse.reduce(
                (acc, curr) => acc + curr.durationInSeconds,
                0,
            );
        }
        return 0;
    }, [getAllTimeTrackerEntitiesWithoutPaginationResponse]);

    return (
        <>
            <Grid item md={gridSize} xs={12}>
                <Typography variant="caption">{field.title}</Typography>
                <AppTimerCounterTypography
                    variant="h3"
                    color={'primary.main'}
                    counterValueInSeconds={totalTrackerValue}
                />
            </Grid>
        </>
    );
};

export default RenderTimeTrackerCounter;
